import React, { memo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { formatNumber } from 'devextreme/localization';

//COLOR AND ARROW FOR INCREASE/DECREASE IN HOURS COMPARED TO PREVIOUS 30 DAYS
//need to:
// - add the css
// - calculate the diff value
const cellRender = (cellData) => {
    return (
        <div className={cellData.diff >= 0 ? 'inc' : 'dec'}>
            <div className="current-value">
                {formatNumber(cellData.value, { type: 'currency', currency: 'USD', precision: 2 })}
            </div>
            <div className="diff">{Math.abs(cellData.diff).toFixed(2)}</div>
        </div>
    );
}


const Hours = memo(function Hours({ data }) {

    const operationColumns = Object.keys(data[0]?.operationsHours || {}).map((key) => (
        <Column key={key} dataField={`operationsHours.${key}`} caption={key} />
    ));

    if (data) {
        return (
            <DataGrid
                dataSource={data}
                columnAutoWidth={true}
                showBorders={true}
            >
                <Column caption="Program Management and Operation Hours - last 30 Days" alignment="center">  
                    <Column caption="Program Management/Engineering" alignment="center">
                        <Column dataField="fulltime" />
                        <Column dataField="student" />
                    </Column>
                    {/*Add operaitons hours dynamically*/}
                    <Column caption="Operations Hours" alignment="center">
                        {operationColumns}
                    </Column>
                </Column>
            </DataGrid>
        )
    }
});

export default Hours;